<template>
  <SettingsManager :settingCategory="section" :key="section">
    {{ title }}
  </SettingsManager>
</template>
<script>
import SettingsManager from "@/components/shared/SettingsManager.vue";
export default {
  components: {
    SettingsManager
  },
  props: {
    section: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  }
};
</script>
